import { colors } from '@atlaskit/theme';
import styled from 'styled-components';

// @source
import { theme } from '../../styles';

export const TableScope = styled.div`
  position: relative;
  height: 300px;
  padding: 1.2rem;
  margin: 1.2rem 0;
  border: 1px solid ${theme.border};
  overflow: auto;
  border-radius: 3px;
`;

export const Table = styled.div`
  width: 100%;
  display: block;
`;

export const TableTitle = styled.div`
  color: ${colors.N500};
  flex: 1 1 auto;
  font-size: .75rem;
  font-weight: bold;
  text-transform: uppercase;
`;

export const TableGroup = styled.div`
  display: block;
  padding-left: 30px;

  & > div:hover {
    background-color: ${theme.background};
  }
`;

export const TableGroupTitle = styled.div`
  flex: 1 1 auto;
  font-size: .75rem;
  font-weight: 600;
  color: ${colors.N400};
  padding: 0 .25rem;
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  padding: .3rem .4rem;
  transition: all linear 50ms;
  border-bottom: 1px solid ${props => (props.isTitle ? theme.border : 'transparent')};
`;

export const TableRowIcon = styled.div`
  position: relative;
  width: 28px;

  & > span {
    display: block;
    margin-top: 2px;
  }
`;

export const TableRowText = styled.div`
  flex: 1 1 auto;
  font-size: .8rem;
  color: ${colors.N300};
`;

export const ChartViewer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
  background-color: #fff;
  overflow: auto;
`;

export const Chart = styled.div`
  position: relative;
  width: 100%;
  min-height: 240px;
  display: block;
  box-sizing: border-box;

  &:not(:first-child) {
    border-top: 5px solid ${theme.border};
  }

  & > div {
    position: relative;
    width: 100%;
    height: 100%;
  }
`;

export const TurnBack = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 200;
  display: inline-block;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
`;
